import React from 'react'
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { MdOutlinePayment } from "react-icons/md";
import logo from '../Assets/opale-nutrition.png'
import '../../Components/Styles/accueil.css';

const Footer = () => {
  return (
    <section className='footer'>
          <div className="footer-container">
            <img className='logo-size' src={logo} alt="" />
            <div className="nav-footer">
              <div className="categories">Alimentation Saine</div>
              <div className="categories">Nutrition</div>
              <div className="categories">Santé Minceur</div>
              <div className="categories">Promo</div>
              <div className="categories">Login</div>
            </div>
          </div>
          <div className="footer-card">
            <div className="footer-info">
              <div className="contact-icon"><FaPhone size={30}/></div>
              <div className="contact-box">
                <div className="contact-title">Par téléphone</div>
                <div className="contact-desc">Au 06.40.15.77.42</div>
              </div>
            </div>
            <div className="footer-info">
              <div className="email-icon"><IoMdMail size={30}/></div>
              <div className="email-box">
                <div className="email-title">Par email</div>
                <div className="email-desc">opalenutrition@gmail.com</div>
              </div>
            </div>
            <div className="footer-info">
              <div className="paiement-icon"><MdOutlinePayment size={30}/></div>
              <div className="paiement-box">
                <div className="paiement-title">Paiement</div>
                <div className="paiement-desc">Par carte bancaire</div>
              </div>
            </div>
            <div className="footer-info">
              <div className="reseaux-box">
                <div className="reseaux-title">Retrouvez nous sur les réseaux</div>
                <div className="reseaux-icon">
                  <a href="" target="_blank">
                    <div className="reseaux-desc"><FaFacebookSquare size={30}/></div>
                  </a>
                  <a href="" target="_blank">
                    <div className="reseaux-desc"><FaInstagram size={30}/></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
  )
}

export default Footer